
import { Injectable } from '@angular/core';
import { OrderParms, StockModuleSettingsParms } from '../../shared/search-params';
import { HttpGeneralService } from '../../shared';

import { CONFIG } from '../../shared/config';

const orderingUrl = CONFIG.baseUrls.ordering;
const stockTransUrl = CONFIG.baseUrls.StockTrans;
const lookupDetailsUrl = CONFIG.baseUrls.lookUpDetails;

@Injectable({
  providedIn: 'root'
})
export class PortalSchedulingManagementService {

  constructor(private _httpGeneral: HttpGeneralService) { }

  getDeviceId(sceduleDeviceIdObject: any) {
    return this._httpGeneral.post(sceduleDeviceIdObject,`${orderingUrl}/getDeviceId`);
  }


  getScheduledResources(obj: ISchedulingManagement) {
    return this._httpGeneral.post(obj, `${orderingUrl}/getSchResourcesForPortal`);
  }

  emrPatListSearch(orderSearch: any) {
    return this._httpGeneral.add(orderSearch, `${orderingUrl}/emrPatListSearch`);
  }

  orderSearch(orderSearch: any) {
    return this._httpGeneral.post(orderSearch, `${orderingUrl}/searchForScheduling`);
  }

  orderDetailSchedule(entity: any[]) {
    return this._httpGeneral.addCollection(entity, `${orderingUrl}/SerivceSchedule`);
  }

  getModuleSettings(parms: StockModuleSettingsParms) {
    return this._httpGeneral.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }

  getServiceStatesByAppCode(id: number) {
    return this._httpGeneral.getWith(`${lookupDetailsUrl}/parent/${id}`);
  }
  getDeviceByDepartment(parentCodeDepartment: any) {
    return this._httpGeneral.add(parentCodeDepartment, `${orderingUrl}/GetDeviceByDepartment`);
  }

  get ModuleId(): number {
    let link = JSON.parse(sessionStorage.getItem('LinkObj'));
    let moduleId: number = +link.parentCode;
    return moduleId;
  }

  private _entityType: number;
  private _secondEntityType: number;
  setEntityType(value: number) {
    this._entityType = value;
  }
  get entityType(): number {
    return this._entityType;
  }

  setSecondEntityType(value: number) {
    this._secondEntityType = value;
  }
  get secondEntityType(): number {
    return this._secondEntityType;
  }
}

export interface ISchedulingManagement {
  ordermaster: OrderParms;
  orderParms: OrderParms;
}
